import React, { useEffect } from 'react';

/**
 * Component to display available appointment slots
 */
const AppointmentSlots = ({ slots, selectedSlot, onSelectSlot, formatTime }) => {
  // Debug logging
  useEffect(() => {
    console.log('AppointmentSlots - slots:', slots);
    console.log('AppointmentSlots - slots is array:', Array.isArray(slots));
    console.log('AppointmentSlots - selectedSlot:', selectedSlot);
    
    if (!Array.isArray(slots)) {
      console.error('slots is not an array!', slots);
    }
  }, [slots, selectedSlot]);
  // Group slots by time period (morning, afternoon, evening)
  const groupedSlots = {
    morning: slots.filter(slot => {
      const hours = slot.startTime.toDate().getHours();
      return hours >= 6 && hours < 12;
    }),
    afternoon: slots.filter(slot => {
      const hours = slot.startTime.toDate().getHours();
      return hours >= 12 && hours < 17;
    }),
    evening: slots.filter(slot => {
      const hours = slot.startTime.toDate().getHours();
      return hours >= 17 && hours < 22;
    })
  };

  // Check if there are slots in each time period
  const hasMorningSlots = groupedSlots.morning.length > 0;
  const hasAfternoonSlots = groupedSlots.afternoon.length > 0;
  const hasEveningSlots = groupedSlots.evening.length > 0;

  return (
    <div className="mb-6">
      <h3 className="text-lg font-semibold mb-3">Available Appointment Slots</h3>
      
      {slots.length === 0 ? (
        <div className="bg-gray-100 p-4 rounded text-center">
          <p className="text-gray-600">No available slots for the selected date.</p>
        </div>
      ) : (
        <div className="space-y-4">
          {hasMorningSlots && (
            <div>
              <h4 className="font-medium text-gray-700 mb-2">Morning</h4>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                {groupedSlots.morning.map(slot => (
                  <div
                    key={slot.id}
                    onClick={() => onSelectSlot(slot)}
                    className={`cursor-pointer p-3 rounded text-center border ${
                      selectedSlot?.id === slot.id
                        ? 'bg-primary/20 border-primary'
                        : 'bg-gray-100 border-gray-300 hover:bg-gray-200'
                    }`}
                  >
                    <div className="font-medium">
                      {formatTime(slot.startTime)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {hasAfternoonSlots && (
            <div>
              <h4 className="font-medium text-gray-700 mb-2">Afternoon</h4>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                {groupedSlots.afternoon.map(slot => (
                  <div
                    key={slot.id}
                    onClick={() => onSelectSlot(slot)}
                    className={`cursor-pointer p-3 rounded text-center border ${
                      selectedSlot?.id === slot.id
                        ? 'bg-primary/20 border-primary'
                        : 'bg-gray-100 border-gray-300 hover:bg-gray-200'
                    }`}
                  >
                    <div className="font-medium">
                      {formatTime(slot.startTime)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {hasEveningSlots && (
            <div>
              <h4 className="font-medium text-gray-700 mb-2">Evening</h4>
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-2">
                {groupedSlots.evening.map(slot => (
                  <div
                    key={slot.id}
                    onClick={() => onSelectSlot(slot)}
                    className={`cursor-pointer p-3 rounded text-center border ${
                      selectedSlot?.id === slot.id
                        ? 'bg-primary/20 border-primary'
                        : 'bg-gray-100 border-gray-300 hover:bg-gray-200'
                    }`}
                  >
                    <div className="font-medium">
                      {formatTime(slot.startTime)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          
          {selectedSlot && (
            <div className="mt-4 p-3 bg-blue-50 rounded border border-blue-200">
              <p className="font-medium text-blue-800">
                Selected Time: {formatTime(selectedSlot.startTime)} - {formatTime(selectedSlot.endTime)}
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default AppointmentSlots;
